"use strict";
/**
 * @file Created on 20.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var NSimulationDTO_1 = require("../model/NSimulationDTO");

var NotificationDocConverter_1 = require("../NotificationDocConverter");

var NSimulationDTOConverter_1 = require("./NSimulationDTOConverter");

var NSimulationProductDTOConverterImpl_1 = require("./NSimulationProductDTOConverterImpl");

var NSimulationWindowDTOConverterImpl_1 = require("./NSimulationWindowDTOConverterImpl");
/**
 * @author Tomas Leity
 */


var NSimulationDTOConverterImpl =
/*#__PURE__*/
function (_NSimulationDTOConver) {
  _inherits(NSimulationDTOConverterImpl, _NSimulationDTOConver);

  /**
   * @param simWindowDTOConverter
   * @param simProductDTOConverter
   */
  function NSimulationDTOConverterImpl(simWindowDTOConverter, simProductDTOConverter) {
    var _this;

    _classCallCheck(this, NSimulationDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NSimulationDTOConverterImpl).call(this));
    _this.simWindowDTOConverter = simWindowDTOConverter;
    _this.simProductDTOConverter = simProductDTOConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(NSimulationDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new NSimulationDTO_1.NSimulationDTO(NSimulationDTO_1.NSimulationDTO.schema.window.valueOf(conversions.asObject(source, 'window', function (obj) {
        return _this2.simWindowDTOConverter.toObject(obj, conversions);
      })), NSimulationDTO_1.NSimulationDTO.schema.products.valueOf(conversions.asObjectList(source, 'products', function (obj) {
        return _this2.simProductDTOConverter.toObject(obj, conversions);
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        window: conversions.asObject(source, 'window', function (obj) {
          return _this3.simWindowDTOConverter.toDocument(obj, conversions);
        }),
        products: conversions.asObjectArray(source, 'products', function (obj) {
          return _this3.simProductDTOConverter.toDocument(obj, conversions);
        })
      });
      return result;
    }
  }]);

  return NSimulationDTOConverterImpl;
}(NSimulationDTOConverter_1.NSimulationDTOConverter);
/**
 * IOC Container qualifier
 */


NSimulationDTOConverterImpl.QUALIFIER = {
  documentType: NSimulationDTO_1.NSimulationDTO.name
};
NSimulationDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject(NSimulationWindowDTOConverterImpl_1.NSimulationWindowDTOConverterImpl.QUALIFIER)), __param(1, typescript_ioc_1.Inject(NSimulationProductDTOConverterImpl_1.NSimulationProductDTOConverterImpl.QUALIFIER)), __metadata("design:paramtypes", [NotificationDocConverter_1.NotificationDocConverter, NotificationDocConverter_1.NotificationDocConverter])], NSimulationDTOConverterImpl);
exports.NSimulationDTOConverterImpl = NSimulationDTOConverterImpl;